import Translate from 'translate.js';
import { languages } from './languages';
// tslint:disable:no-any
var defaultLanguage = 'es';
var detectedLanguage = ((navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage).toLowerCase();
export var lang = detectedLanguage.substr(0, 2);
export var langAndRegion = detectedLanguage;
var translate = Translate(languages[lang] || languages[defaultLanguage], {
    debug: process.env.NODE_ENV === 'development',
    namespaceSplitter: ':'
});
export var capitalize = function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
export var capitalizeAll = function (text) { return text.toUpperCase(); };
export var t = function (key, replacements) {
    return translate(key, replacements);
};
export var T = function (key, replacements) {
    return capitalize(t(key, replacements));
};
export var TT = function (key, replacements) {
    return capitalizeAll(t(key, replacements));
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/i18n.ts
// module id = 2
// module chunks = 0